import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import errorCode from '@/utils/errorCode'
import { getToken } from '@/utils/auth'


// 是否显示重新登录
export let isReLogin = { show: false };


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: "https://admin.zhihuiyanglao.com.cn/api",
  // baseURL: "http://localhost:8080/api",
  // baseURL: "http://bhang.qiangdaoapp.com/api",
  // 超时
  timeout: 5000
})

// 取消请求：防止数据重复提交
let cancelTokenMap = {};
let cancelToken = (config) => {
  const key = config.cancelToken;
  if (!key) return;
  let task = cancelTokenMap[key];
  if (task) {
    task("cancelToken");
  }
  config.cancelToken = new axios.CancelToken((cancel) => {
    cancelTokenMap[key] = cancel;
  });
}

// request拦截器
service.interceptors.request.use((config) => {
  cancelToken(config);
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  //
  config.headers["UUCODE"] = localStorage.UUCODE;
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, (error) => {
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  // 二进制数据则直接返回
  if (code === 200 && res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    let fileName = (res.headers['content-disposition'] || '').replace(/.*filename\=(.*)/, '$1');
    let blob = new Blob([res.data]);
    blob.fileName = decodeURIComponent(fileName);
    return blob
  }
  if (code === 401) {
    if (!isReLogin.show) {
      isReLogin.show = true;
      MessageBox.confirm('为了更好地向您提供服务，请先登录本平台', '系统提示', {
        confirmButtonText: '去登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).then(() => {
        isReLogin.show = false;
        // 重新登录
        location.href = '#/login';
      }).catch(() => {
        isReLogin.show = false;
      });
    }
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  } else if (code === 500) {
    Message({
      message: msg,
      type: 'error'
    })
    return Promise.reject(new Error(msg))
  } else if (code !== 200) {
    Notification.error({
      title: msg
    })
    return Promise.reject('error')
  } else {
    return res.data
  }
}, error => {
  //console.log('err' + error)
  let { message } = error;
  if (message === "cancelToken") {
    return Promise.reject(error);
  }
  //
  if (message == "Network Error") {
    message = "后端接口连接异常";
  } else if (message.includes("timeout")) {
    message = "系统接口请求超时";
  } else if (message.includes("Request failed with status code")) {
    message = "系统接口" + message.substr(message.length - 3) + "异常";
  }
  Message({
    message: message,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js